<template>
  <div>
    <ul class="space-y-4">
      <li v-for="reviewer in reviewers" :key="reviewer.id">
        <span class="text-sm font-medium text-gray-600">By {{ reviewer.fullName }}</span>

        <ul class="grid grid-cols-5 gap-4 p-4">
          <li
            v-for="projectAsset in projectAssetsByReviewerId[reviewer.id]"
            :key="projectAsset.id"
            class="flex flex-col space-y-2"
          >
            <ProjectAssetTile :project-asset="projectAsset" :entities="entities" />
            <ApprovalRequestRevokeAction
              v-if="hasApprovalRequestByProjectAssetIdAndReviewerId(projectAsset.id, reviewer.id)"
              :approval-request-id="
                getApprovalRequestByProjectAssetIdAndReviewerId(projectAsset.id, reviewer.id).id
              "
              :project-asset-id="projectAsset.id"
              @approval-request-revoked="$emit('approval-request-revoked')"
            />
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import ApprovalRequestRevokeAction from 'Components/ProjectAssetApprovalRequests/ApprovalRequestRevokeAction.vue';
import ProjectAssetTile from './ProjectAssetTile.vue';

export default {
  components: {
    ApprovalRequestRevokeAction,
    ProjectAssetTile,
  },
  props: {
    selectedReviewerIds: {
      type: Array,
      default: () => [],
    },
    projectAssetIds: {
      type: Array,
      required: true,
    },
    entities: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    reviewers() {
      const allReviewerIds = Object.keys(this.entities.projectAssets).reduce(
        (reviewerIds, projectAssetId) => [
          ...reviewerIds,
          ...(this.entities.projectAssets[projectAssetId]?.reviewers || []).filter(
            (reviewer) => typeof reviewer === 'string'
          ),
        ],
        []
      );

      return Array.from(new Set(allReviewerIds))
        .filter((reviewerId) => this.selectedReviewerIds.indexOf(reviewerId) >= 0)
        .map((reviewerId) => this.entities.users[reviewerId])
        .filter(Boolean);
    },
    projectAssetsByReviewerId() {
      return this.reviewers.reduce(
        (carry, reviewer) => ({
          ...carry,
          [reviewer.id]: Object.values(this.entities.projectAssets).filter(
            (projectAsset) => projectAsset.reviewers.indexOf(reviewer.id) >= 0
          ),
        }),
        {}
      );
    },
    approvalRequestsByReviewerId() {
      return this.reviewers.reduce((carry, reviewer) => {
        const approvalRequest = Object.values(this.entities.approvalRequests).find(
          (a) => a.userId === reviewer.id
        );

        return approvalRequest
          ? {
              ...carry,
              [reviewer.id]: { ...approvalRequest },
            }
          : carry;
      }, {});
    },
  },
  methods: {
    hasApprovalRequestByProjectAssetIdAndReviewerId(projectAssetId, reviewerId) {
      return (
        typeof this.getApprovalRequestByProjectAssetIdAndReviewerId(projectAssetId, reviewerId) !==
        'undefined'
      );
    },
    getApprovalRequestByProjectAssetIdAndReviewerId(projectAssetId, reviewerId) {
      return Object.values(this.entities.approvalRequests).find(
        (approvalRequest) =>
          approvalRequest.approvableId === projectAssetId && approvalRequest.userId === reviewerId
      );
    },
  },
};
</script>
